import React from 'react';

export const BriefSummaryTitleLabels = () => {
    return <h1>A Brief Summary of Myself</h1>;
}

export const BriefSummaryContentLabels = () => {
    return (
        <p>
            I’m a full-stack developer using my technical skills to contribute to nonprofit 
            and civic tech initiatives. With a Graduate Certificate in Engineering from UTS (2023), 
            I specialize in modern web technologies like .NET and React. I’m passionate about building 
            tools that make a difference — whether that’s through volunteering, maintaining open-source 
            projects, or creating platforms that support community initiatives. Currently, I maintain 
            frontend development for Parramatta Eisteddfod thru Code.Sydney and continue to grow my 
            skills in data structures and algorithms. Let’s build something that matters.
        </p>
    );
}